var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid overflow-auto page-container-h"},[_c('bread-crumb',{attrs:{"bread_crumb_data":_vm.view.bread_crumb_data}}),_vm._v(" "),_c('tables-page',{attrs:{"tableData":_vm.data.table_data,"tableFields":_vm.data.table_fields}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596afa6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Backstage/yf/salesAgeDistribution.vue
// module id = null
// module chunks = 